import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { RequisitionRead } from '../../entities/requisition.dto';

@Injectable()
export class RequisitionStore extends AbstractEntityStore<RequisitionRead> {
    constructor() {
        super(PFWmsEntities.Requisition);
    }
}
